module.exports = {"id":"189358","name":"Shinji Kagawa","rating":"83","photo":"./data/images/photos/3/189358.png","club":{"name":"Bor. Dortmund","logo":"./data/images/clubs/Bor.Dortmund.png"},"positions":["MOC","ATT","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ShinjiKagawa0.json
// module id = 3938
// module chunks = 0